/**
 * Used for cases when server returned response with HTTP code between 400 and 599
 */
export class BadResponseError {
    public readonly name = 'BadResponseError';

    public constructor(
        public readonly message: string,
        public readonly code: number,
    ) {
    }
}
